import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { cn } from '@/utils/cn'
import { formatDistributionCenterName } from '@/utils/formatters'
import {
  formatFullDate,
  type ExportDetailRow,
} from './eventProductFlowMockData'

interface Props {
  rows: ExportDetailRow[]
}

export function ExportDetailedViewTable({ rows }: Props) {
  return (
    <div className="max-h-[640px] overflow-auto rounded-lg border border-border bg-white shadow-sm">
      <Table>
        <TableHeader className="sticky top-0 z-10 bg-white">
          <TableRow className="hover:bg-transparent">
            <TableHead>Season</TableHead>
            <TableHead>Event</TableHead>
            <TableHead>POG Group</TableHead>
            <TableHead>DC</TableHead>
            <TableHead>PO</TableHead>
            <TableHead>SKU</TableHead>
            <TableHead>Import/Domestic</TableHead>
            <TableHead>Initial/Replen</TableHead>
            <TableHead>Milestone Classification</TableHead>
            <TableHead>Milestone Group</TableHead>
            <TableHead>Milestone Name</TableHead>
            <TableHead className="text-right">Milestone Order</TableHead>
            <TableHead>Expected Date</TableHead>
            <TableHead>Projected Date</TableHead>
            <TableHead className="text-right">Delay Days</TableHead>
            <TableHead className="text-right">Units Total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.id}>
              <TableCell>{row.season}</TableCell>
              <TableCell>{row.event}</TableCell>
              <TableCell>{row.pogGroup}</TableCell>
              <TableCell>{formatDistributionCenterName(row.dc)}</TableCell>
              <TableCell>{row.po}</TableCell>
              <TableCell>{row.sku}</TableCell>
              <TableCell>{row.importDomestic}</TableCell>
              <TableCell>{row.initialReplenReset}</TableCell>
              <TableCell>{row.milestoneClassification}</TableCell>
              <TableCell>{row.milestoneGroup}</TableCell>
              <TableCell>{row.milestoneName}</TableCell>
              <TableCell className="text-right tabular-nums">
                {row.milestoneOrder}
              </TableCell>
              <TableCell className="tabular-nums">
                {formatFullDate(row.expectedDate)}
              </TableCell>
              <TableCell className="tabular-nums">
                {formatFullDate(row.projectedDate)}
              </TableCell>
              <TableCell
                className={cn(
                  'text-right tabular-nums',
                  row.delayDays > 0 && 'text-destructive'
                )}
              >
                {row.delayDays}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {row.unitsTotal.toLocaleString('en-US')}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
